// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 873) return "static/chunks/873.9e955b847b4d4323.js";
	if (chunkId === 857) return "static/chunks/857.0f67832e4ad1c4b1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"30":"7e3c4fd98d92ae66","388":"c8b91dc79800750e","675":"34bc4b697536eecd"}[chunkId] + ".js";
};